module.exports = __webpack_public_path__ + "static/media/Payslip_Template_1.031a8eac.png";